var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-button',{staticClass:"clear-button mr-2",attrs:{"type":"secondary"},on:{"click":_vm.clearFilters}},[_vm._v("Limpar")])
}
var staticRenderFns = []

export { render, staticRenderFns }